import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";

const PopoverHeader = styled.h3`
  background: ${cloud.getShade(2)};
  color: ${cloud.getShade(9)};
  padding: 6px 16px;
  border-bottom: 1px solid ${cloud.getShade(3)};
  font-size: 1.5rem;
  font-weight: 500;
`;

export default PopoverHeader;
